// extracted by mini-css-extract-plugin
export default {"user":"style_user__XObMd","content":"style_content__S2CpJ","formContent":"style_formContent__UmQXj"};